<script setup>
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  controlItem: {
    type: Object,
    default: () => ({}),
  },
});

const router = useRouter();

const onClick = name => {
  router.push({ name });
};
</script>

<template>
  <div
    :key="controlItem.name"
    class="p-5 gap-3 flex flex-col w-full rounded-2xl border border-slate-200 bg-white hover:bg-slate-50 transition-colors cursor-pointer group"
    @click="onClick(controlItem.routeName)"
  >
    <div class="flex items-start justify-between w-full gap-3">
      <div class="flex items-start gap-3 min-w-0">
        <div
          class="w-10 h-10 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center text-slate-900 flex-shrink-0"
        >
          <span
            class="size-5"
            :class="[controlItem.icon || 'i-lucide-sliders-horizontal']"
          />
        </div>
        <div class="min-w-0">
          <div class="text-sm font-semibold text-slate-900 line-clamp-1">
            {{ controlItem.name }}
          </div>
          <div class="text-slate-600 text-sm leading-[21px] line-clamp-3">
            {{ controlItem.description }}
          </div>
        </div>
      </div>

      <Button
        icon="i-lucide-chevron-right"
        variant="ghost"
        color="slate"
        size="xs"
        class="group-hover:brightness-110"
        @click="onClick(controlItem.routeName)"
      />
    </div>
  </div>
</template>
